import { declareString } from "@1js/localization";

export const TipsTitle = declareString("promptLibrary.tipsTitle", {
  text: "Quick tips for better prompts",
  comment: `Title that appears above tips section. This section is for users to understand what is the best way to write a prompt and get the best output. 'prompts' is the text input provided to AI model like GPT`,
});
